import axios from "axios";
import EventBus from "../common/EventBus";

const API_BACKEND_URL = "https://smartelec.eu.org/app_back_tags/";

const basicAuth = 'Basic ' + btoa('smartelec:Ap4nET9GbCjx2g');

const getDeviceTagLocations = async (keys, days) => {
  const token = localStorage.getItem("token");
  const headers = {
    'Authorization': basicAuth,
    // 'JwtToken': token,
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': '*/*',
    'Accept-Language': 'fr-FR,fr;q=0.9,en-US;q=0.8,en;q=0.7',
  };

  return axios
    .post(
      API_BACKEND_URL + "reports",
      {
        keys: keys,
        days: days,
      },
      {
        headers: headers,
      }
    )
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      if (error.response && error.response.status === 401) {
        // Handle unauthorized error (basic auth failed)
        EventBus.dispatch("logout");
      }
    });
};

const BackendTagsService = {
  getDeviceTagLocations,
};

export default BackendTagsService;
